import packageInfo from '../../package.json';

export const environment = {
	production: true,
	apiUrl: 'https://tacit-api.qatar.northwestern.edu',
	version: packageInfo.version,
};
